export default __webpack_public_path__ + "static/media/avatar_panda3.2ce12321.mp3";